import { useEffect, useState } from "react"
import { apiResult, getUserSession } from "../../Utils/Common"
import apis from "../../api"
import { Alert, Box, Container, FormControl, Grid, IconButton, InputLabel, MenuItem, Paper, Select, TextField, Toolbar, Typography } from "@mui/material"
import { Search } from "@mui/icons-material"
import MyTable from "../../Component/MyTable"
import { Title } from "../../Component/MuiEx"

const MonthReport = () => {
    const [data, setData] = useState()
    const [error, setError] = useState()
    
    const currentYear = new Date().getFullYear()
    const [fields, setFields] = useState({from_year:currentYear,from_month:"01",to_year:currentYear,to_month:"12"})
    getUserSession(apis)
    const handleChange = (k, v) => {
        setFields({ ...fields, [k]: v })
    }
    const onSearch = () => {
        setError()
        if (!fields["from_year"] || !fields["from_month"] || !fields["to_year"] || !fields["to_month"]) {
            setError("Please set time period")
            return
        }
        let from = fields["from_year"] + "-" + fields["from_month"] + "-01"
        let to = fields["to_year"] + "-" + fields["to_month"] + "-01"
        if (from >= to) {
            setError("Please set valid time period")
            return
        }
        apis.monthReport(from, to).then(ret => {
            apiResult(ret, retdata => {
                let table = { total: [] }
                for (let i = 0; i < retdata.length; i++) {
                    let r = retdata[i]
                    if (!table[r.name]) {
                        table[r.name] = []
                    }
                    table[r.name].push(r)
                    let f = false
                    for (let j = 0; j < table.total.length; j++) {
                        if (table.total[j].month == r.month) {
                            table.total[j].settle_fee += Number(+r.settle_fee)
                            table.total[j].settle_tax += Number(+r.settle_tax)
                            table.total[j].times += Number(+r.times)
                            table.total[j].members += Number(+r.members)
                            f = true
                            break
                        }
                    }
                    if (!f) {                        
                        table.total.push({month:r.month,settle_fee:Number(+r.settle_fee),settle_tax:Number(+r.settle_tax),times:Number(+r.times),members:Number(+r.members)})
                    }
                }
                setData(table)
            })
        })
    }
    const tableHeader = [
        { name: "month", showName: "Month" },
        { name: "settle_fee", showName: "Settle Fee" ,func:(v,idx,row)=>{return parseFloat(v).toFixed(2)}},
        { name: "settle_tax", showName: "Settle Tax" ,func:(v,idx,row)=>{return parseFloat(v).toFixed(2)}},
        { name: "times", showName: "Lessons" },
        { name: "members", showName: "Members" },
    ]
    return <Box>
        <Paper sx={{ marginBottom: 2, width:"100%",p:1}} >
            <Toolbar style={{ paddingLeft: 2, width:"100%" }}>
                <FormControl fullWidth sx={{ mr: 2,width:"200px" }}>
                    <InputLabel id="from-year">From Year</InputLabel>
                    <Select
                        labelId="from-year"
                        id="from-year"
                        label="From Year"
                        value={fields["from_year"]}
                        onChange={(e) => handleChange("from_year", e.target.value)}>
                        {[currentYear - 2, currentYear - 1, currentYear].map((y, idx) => {
                            return <MenuItem value={y}>{y}</MenuItem>
                        })}
                    </Select>
                </FormControl>
                <FormControl fullWidth sx={{ mr: 2 ,width:"200px" }}>
                    <InputLabel id="from-month">From Month</InputLabel>
                    <Select
                        labelId="from-month"
                        id="from-month"
                        label="From Month"
                        value={fields["from_month"]}
                        onChange={(e) => handleChange("from_month", e.target.value)}>
                        {["01", "02", "03", "04", "05", "06", "07", "08", "09", "10", "11", "12"].map((y, idx) => {
                            return <MenuItem value={y}>{y}</MenuItem>
                        })}
                    </Select>
                </FormControl>
                <FormControl fullWidth sx={{ mr: 2,width:"200px"  }}>
                    <InputLabel id="to-year">To Year</InputLabel>
                    <Select
                        labelId="to-year"
                        id="to-year"
                        label="To Year"
                        value={fields["to_year"]}
                        onChange={(e) => handleChange("to_year", e.target.value)} >
                        {[currentYear - 2, currentYear - 1, currentYear].map((y, idx) => {
                            return <MenuItem value={y}>{y}</MenuItem>
                        })}
                    </Select>
                </FormControl>
                <FormControl fullWidth sx={{ mr: 2,width:"200px"  }}>
                    <InputLabel id="to-month">To Month</InputLabel>
                    <Select
                        labelId="to-month"
                        id="to-month"                        
                        label="To Month"
                        value={fields["to_month"]}
                        onChange={(e) => handleChange("to_month", e.target.value)}>
                        {["01", "02", "03", "04", "05", "06", "07", "08", "09", "10", "11", "12"].map((y, idx) => {
                            return <MenuItem value={y}>{y}</MenuItem>
                        })}
                    </Select>
                </FormControl>
                <IconButton onClick={onSearch}><Search /></IconButton>
                <Typography sx={{ flex: '1 1 10%' }} variant="h6" component="div" > </Typography>
                {error && <Alert variant="error">{error}</Alert>}
            </Toolbar>
        </Paper>
        {data && <Grid container spacing={2}>
            <Grid item sm={4} xs={12}>
                <Title>Total</Title>
                <MyTable
                    rows={data["total"]}
                    totalRow={data["total"].length}
                    headers={tableHeader}
                    checkbox={false}
                    rowsPerPage={data["total"].length}
                    showPageination={false}
                />
            </Grid>
            {Object.keys(data).map(k => {
                if (k == "total") return
                let obj = data[k]
                return <Grid item xs={12} sm={4}>
                    <Title>{k}</Title>
                    <MyTable
                    rows={obj}
                    totalRow={obj.length}
                    headers={tableHeader}
                    checkbox={false}
                    rowsPerPage={obj.length}
                    showPageination={false}
                /></Grid>
            })}
        </Grid>}
    </Box>
}


export default MonthReport